<template>
  <div>
    <a-table
      :columns="columns"
      :row-key="(record) => record.id"
      :data-source="prestations"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template #company="{ record }">
        <div style="color: black; font-weight: #2b3e50">
          {{ record.company.name }}
        </div>
        <div style="color: #647c92">{{ record.company.internal_number }}</div>
      </template>

      <template #frais_reels="{ record }">
        <div>
          <div style="color: green">
            <span v-money-format="record.presta.fr.t"></span> €
          </div>
          <div style="color: olive">
            <span v-money-format="record.presta.fr.l"></span> €
          </div>
        </div>
      </template>

      <template #remboursement_ro="{ record }">
        <div>
          <div style="color: green">
            <span v-money-format="record.presta.ss.t"></span> €
          </div>
          <div style="color: olive">
            <span v-money-format="record.presta.ss.l"></span> €
          </div>
        </div>
      </template>

      <template #remboursement_autre_mutuelle="{ record }">
        <div>
          <div style="color: green">
            <span v-money-format="record.presta.au.t"></span> €
          </div>
          <div style="color: olive">
            <span v-money-format="record.presta.au.l"></span> €
          </div>
        </div>
      </template>

      <template #remboursement_cpms_base="{ record }">
        <div>
          <div style="color: green">
            <span v-money-format="record.presta.b.t"></span> €
          </div>
          <div style="color: olive">
            <span v-money-format="record.presta.b.l"></span> €
          </div>
        </div>
      </template>

      <template #remboursement_cpms_opt_surc="{ record }">
        <div>
          <div style="color: green">
            <span v-money-format="record.presta.o.t + record.presta.s.t"></span>
            €
          </div>
          <div style="color: olive">
            <span v-money-format="record.presta.o.l + record.presta.s.l"></span>
            €
          </div>
        </div>
      </template>
      <template #remboursement_cpms_total="{ record }">
        <div>
          <div style="color: green">
            <span v-money-format="record.presta.t.t"></span> €
          </div>
          <div style="color: olive">
            <span v-money-format="record.presta.t.l"></span> €
          </div>
        </div>
      </template>
    </a-table>
  </div>
</template>

<script>
const columns = [
  {
    title: "Entreprise",
    width: 220,
    dataIndex: "company_name",
    key: "company_name",
    defaultSortOrder: "ascend",
    slots: {
      customRender: "company_name",
    },
  },
  {
    title: "Frais réels",
    width: 220,
    align: "right",
    dataIndex: "frais_reels",
    key: "frais_reels",
    slots: {
      customRender: "frais_reels",
    },
  },
  {
    title: "Remboursement RO ",
    width: 100,
    align: "right",
    dataIndex: "remboursement_ro",
    key: "remboursement_ro",
    slots: {
      customRender: "remboursement_ro",
    },
  },
  {
    title: "Remboursement autre mutuelle",
    width: 100,
    align: "right",
    dataIndex: "remboursement_autre_mutuelle",
    key: "remboursement_autre_mutuelle",
    slots: {
      customRender: "remboursement_autre_mutuelle",
    },
  },
  {
    title: "Remboursement CPMS Base",
    width: 100,
    align: "right",
    dataIndex: "remboursement_cpms_base",
    key: "remboursement_cpms_base",
    slots: {
      customRender: "remboursement_cpms_base",
    },
  },
  {
    title: "Remboursement CPMS Opt/Surc",
    width: 100,
    align: "right",
    dataIndex: "remboursement_cpms_opt_surc",
    key: "remboursement_cpms_opt_surc",
    slots: {
      customRender: "remboursement_cpms_opt_surc",
    },
  },
  {
    title: "Remboursement CPMS total",
    width: 100,
    align: "right",
    dataIndex: "remboursement_cpms_total",
    key: "remboursement_cpms_total",
    slots: {
      customRender: "remboursement_cpms_total",
    },
  },
];

export default {
  name: "PrestationHoldingTable",
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sTLy: {},
      columns,

      sort: {
        columnKey: null,
        order: null,
      },

      prestationsData: {
        data: [],
      },

      loading: false,

      timeout: 0,
    };
  },
  watch: {
    spaEr(_) {
      // Reset Pagination
      this.params.page = 1;
      this.getPrestations();
    },
    _searchValue(_) {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.params.page = 1;
        this.getPrestations();
      }, 500);
    },
  },
  methods: {
    getPrestations() {
      this.loading = true;

      let url = `data/prestations/${this.numHolding}/?${new URLSearchParams(
        this.params
      )}`;

      this.axios.get(url).then((r) => {
        if (r.status === 200) {
          this.prestationsData = r.data;

          setTimeout(() => {
            this.loading = false;
          }, 100);
        }
      });
    },
    getSoin(soin) {
      if (soin == "FR") return "Forfaits";
      if (soin == "CV") return "Consultat./Visites";
      if (soin == "HO") return "Hospitalisation";
      if (soin == "OP") return "Optique";
      if (soin == "PH") return "Pharmacie";
      if (soin == "SC") return "Soins courants";
      if (soin == "AD") return "Art Dentaire";
      if (soin == "TT") return "Totaux";
      return "Autre";
    },
    handleTableChange(pag, _, sorter) {
      this.loading = true;
      this.sort.columnKey = sorter.columnKey;
      this.sort.order = sorter.order;

      this.params.page = pag.current;

      this.getPrestations();
    },
  },
  computed: {
    _searchValue() {
      return this.params.searchValue;
    },
    spaEr() {
      return this.params.spaEr.spa + this.params.spaEr.er.status;
    },
    numHolding() {
      return this.$route.params.numHolding;
    },
    numEntreprise() {
      return this.$route.params.numEntreprise;
    },
    headers() {
      return this.$store.getters.headers.hhp;
    },
    ac() {
      return this.$store.getters.activeColumns.h;
    },
    noZeroData() {
      return this.$store.getters.noZeroData.h;
    },
    pagination() {
      return {
        total: this.prestationsData.total,
        current: this.prestationsData.current_page,
        columnKey: this.params.columnKey,
        order: this.params.order,
      };
    },
    translate() {
      return this.$store.getters.translate;
    },
    prestations() {
      return this.prestationsData.data.filter((c) => {
        return c;
      });
    },
  },
  mounted() {
    this.getPrestations();
  },
};
</script>